import { Check } from "lucide-react";
import { useLang } from "@/context/LangContext";

export const TrustStrip = () => {
  const { t } = useLang();
  const items = [
    { id: "third-party", label: t("trust_third_party") },
    { id: "us-sourced", label: t("trust_us_sourced"), sub: t("trust_us_sourced_sub") },
    { id: "secure-payments", label: t("trust_secure_payments") },
    { id: "support", label: t("trust_support") },
  ];
  return (
    <section data-testid="trust-strip" className="relative border-y border-slate-500/15 bg-[#0D1015]">
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-slate-400/[0.035] to-transparent pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 md:py-7 relative">
        <div className="grid grid-cols-2 gap-x-6 gap-y-5 lg:flex lg:items-center lg:justify-between">
          {items.map((item) => (
            <div key={item.id} data-testid={`trust-item-${item.id}`} className="flex items-start gap-3">
              <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full border border-slate-400/30 bg-slate-400/[0.08]">
                <Check className="w-3 h-3 text-slate-200" strokeWidth={2.5} />
              </span>
              <span>
                <span className="metallic-text text-sm font-semibold tracking-wide block">{item.label}</span>
                {item.sub && (
                  <span className="text-slate-500 text-[11px] leading-snug block mt-0.5 max-w-[230px]">{item.sub}</span>
                )}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
